import React, { useEffect } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { FormFields } from '~/components/FormFields'
import { FieldComponentProps } from './types'
import { LabelWithInfo } from '../util'

const CantonField: React.FC<FieldComponentProps> = ({ field, name, countries = [], disabled }) => {
  const { control } = useFormContext()
  const { t } = useTranslation()

  const swissCountry = countries.find(country => country.iso === 'ch')
  const cantonOptions = swissCountry?.cantons?.map(canton => ({ value: Number(canton.id), text: canton.label })) || []
  const required = !disabled && Boolean(field.fieldRequired)

  return (
    <FormFields.Select
      control={control}
      disabled={disabled}
      placeholder={'-'}
      search={!disabled}
      rules={{
        required
      }}
      selectOnBlur={false}
      noResultsMessage={t('No results found....')}
      name={`${name}.value`}
      label={<LabelWithInfo label={field.label} info={field.info} required={required} />}
      options={cantonOptions}
    />
  )
}

export default CantonField
